import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ReactComponent as YellowAlert } from '@assets/svg-imports/Icon-warning.svg';
import { deleteAzure } from '@api/api_services';
import { AZURE_DEVOPS_CONSTANTS } from '../plugin_constants';

function AzureDeleteInstance(props) {
  const deleteBitBucketInstance = async () => {
    try {
      const response = await deleteAzure(props.data.id);
      if (response?.data?.responseCode == 200) {
        props.closeModal();
        props.reloadTree();
        props.MyAlert.success(`${props.data.name} ${response.data.message}`);
      } else {
        props.MyAlert.warning(response?.data?.message);
      }
    } catch (err) {
      console.error('Api error ', err);
    }
  };
  return (
    <>
      <Modal
        open={props.openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="focus:outline-none outline-none"
      >
        <Box className="deleteModal focus:outline-none outline-none">
          <div className="headerdelete">
            <div className="successImg">
              <YellowAlert className="svgImgWarning" />
            </div>
            <div className="mt-5 ">
              <div className="flex flex-row">
                <p className="svgYellow fontPoppinsMediumXX2 ml-5">{AZURE_DEVOPS_CONSTANTS.WARNING}</p>
                <p className="fontPoppinsMediumXX2 ml-2 delete-content">{AZURE_DEVOPS_CONSTANTS.DELETE}</p>
              </div>
              <div className="fontPoppinsRegularLg ml-6 mt-4  flex flex-col">
                <span className="fontPoppinsRegularMd delete-content">
                  {AZURE_DEVOPS_CONSTANTS.DATA_LOST}
                  <br />
                  <span className="fontPoppinsSemiboldMd delete-content">{props?.data?.name}</span>{' '}
                  {AZURE_DEVOPS_CONSTANTS.INSTANCE} ?
                </span>
                <span className="mt-4 fontPoppinsRegularMd  delete-content">{AZURE_DEVOPS_CONSTANTS.PROCEED}</span>
              </div>
            </div>
          </div>
          <div className="delete-footer flex  -mx-1">
            <button
              className="button-cancel success-instance cursor-pointer fontMontserratMediumXs"
              onClick={props.closeModal}
            >
              {AZURE_DEVOPS_CONSTANTS.CANCEL}
            </button>
            <button
              className="delete-button cancel-instance  cursor-pointer fontMontserratMediumXs"
              onClick={deleteBitBucketInstance}
            >
              {AZURE_DEVOPS_CONSTANTS.DELETE}
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default AzureDeleteInstance;
